import React from 'react';
import styles from './TextEffectsGlass.scss';
import type { TextEffectsSharedProps } from '../../TextEffectsShared/TextEffectsShared.types';
import TextEffectsShared from '../../TextEffectsShared/viewer/TextEffectsShared';
import { blurConfig, TestIds } from '../constants';
import useUniqueSvg, {
  createSvgManager,
} from '../../TextEffectsShared/viewer/useUniqueSvg';
import { range } from '../../TextEffectsShared/editor/panels/design/utils';
import cx from 'clsx';
import { usePatterns, Patterns } from '../../TextEffectsShared/viewer/patterns';

const svgManager = createSvgManager(`
  <defs>
    <filter id="lightA3">
      <feGaussianBlur in="SourceAlpha" stdDeviation="3" result="B" />
      <feSpecularLighting in="B" specularExponent="128" result="S">
        <feDistantLight azimuth="225" elevation="70" />
      </feSpecularLighting>
      <feComposite in="S" in2="SourceAlpha" operator="in" result="L" />
      <feComposite
        in="SourceGraphic"
        in2="L"
        operator="arithmetic"
        k2="1"
        k3="1"
      />
    </filter>
    ${range(blurConfig.start, blurConfig.end, blurConfig.step)
      .map(
        num => `
      <filter id="glass-shadow_blur:${num}">
        <feGaussianBlur stdDeviation="${num}" in="SourceAlpha" />
        <feOffset result="fO" dy="5" dx="5" />
        <feComposite in2="fO" operator="xor" in="SourceGraphic" />
      </filter>
    `,
      )
      .join('\n')}
  </defs>
`);

export type TextEffectsGlassProps = TextEffectsSharedProps;

const TextEffectsGlass: React.FC<TextEffectsSharedProps> = props => {
  const { content, arePatternsDisabled } = usePatterns(props);

  useUniqueSvg(svgManager);

  return (
    <TextEffectsShared
      {...props}
      arePatternsDisabled={arePatternsDisabled}
      tagProps={{
        className: styles.root,
        'data-testid': TestIds.viewer.container,
      }}
    >
      <Patterns
        content={content}
        arePatternsDisabled={arePatternsDisabled}
        patternScope={props.patternScope}
        unitProps={data => ({
          className: styles.container,
          'data-text': data,
          disabledPattern: arePatternsDisabled,
        })}
        unitPredicate={data => (
          <span
            className={cx(styles.text, styles.block)}
            data-testid={TestIds.viewer.text}
          >
            {data}
          </span>
        )}
      />
    </TextEffectsShared>
  );
};

export default TextEffectsGlass;
